import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/dna-mw/pages/CalculatorPage";

export const Route = createFileRoute("/dna-rna-molecular-weight")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/dna-rna-molecular-weight",
      title: m.dnamw_meta_title(),
      description: m.dnamw_meta_description(),
      toolName: m.dnamw_tool_name(),
      faqs: [
        { q: m.dnamw_faq_q1(), a: m.dnamw_faq_a1() },
        { q: m.dnamw_faq_q2(), a: m.dnamw_faq_a2() },
        { q: m.dnamw_faq_q3(), a: m.dnamw_faq_a3() },
        { q: m.dnamw_faq_q4(), a: m.dnamw_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
